import React, { useEffect } from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import { useHeroMessageTest } from "../../hooks/useABTest";

const Hero = ({ heroImage }) => {
    // A/B Testing para mensaje hero
    const { variant, config } = useHeroMessageTest();

    useEffect(() => {
        if (!variant) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'funnel_hero_impression',
            hero_variant: variant
        });
    }, [variant]);

    // Manejar click en CTA
    const handleCTAClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'funnel_hero_click',
            hero_variant: variant
        });
    };

    return (
        <>
            <section className="containerBox flexCol">
                <picture className="heroPicture">
                    <source srcSet="/hero.avif" type="image/avif" />
                    <source srcSet="/hero.webp" type="image/webp" />
                    <img
                        className="heroBackgroundImage"
                        src={heroImage}
                        alt="Familia protegida con sistema de alarma ADT en el hogar"
                        fetchpriority="high"
                        loading="eager"
                        decoding="async"
                    />
                </picture>
                <div className="landingContent flex flexCol alignCenter">
                    <h1>{config.title || 'Cotizá el sistema de seguridad ADT en muy pocos clicks'}</h1>
                    <p>
                        {config.subtitle || 'Recibí de forma simple las mejores opciones y packs de seguridad para tu casa o comercio y contratá tu alarma con profesionales.'}
                    </p>
                    <Link
                        to="/cotizador"
                        className="btn"
                        onClick={handleCTAClick}
                    >
                        {config.cta || 'Ver Promos y Precios'}
                    </Link>
                </div>
            </section>
            <section className="flexCol infoBox">
                <div className="stepsHome flexRow">
                    <h2>Accedé a tu Alarma ADT</h2>
                    <div className="stepHomeBox flexRow">
                        <div className="stepHome">
                            <span className="stepNumber">1</span>
                            <p>Completás la info</p>
                        </div>
                        <div className="stepHome">
                            <span className="stepNumber">2</span>
                            <p>Elegís tu Pack</p>
                        </div>
                        <div className="stepHome">
                            <span className="stepNumber">3</span>
                            <p>Recibís tu Instalación</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Hero;
